import { createAction } from '@reduxjs/toolkit';

import { SUBMIT_REGISTRATION_FORM } from './actionTypes';
import { IRegistrationSubmitProps } from './types';

export const submitRegistrationForm =
  createAction<IRegistrationSubmitProps>(SUBMIT_REGISTRATION_FORM);
